import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import * as Yup from 'yup'
import moment from 'moment-timezone'
import { Formik, Form, ErrorMessage } from 'formik'
import { connect } from 'react-redux'
import { Box, InputAdornment, Typography, TextField, MenuItem, Checkbox, Divider, ClickAwayListener, Radio, Grid, Tooltip } from '@material-ui/core'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { Breadcrumb, AppButton, Loader, DisplayMessage } from '../../Components'
import { Cards, Popup, DateTimePicker } from '../../elements'
import { eventForm, CalendarFormat, eventTypes, eventSubTypeMapper, eventSubTypes, eventTypeMapper, energyBasedEventForm, EVENT_TYPE } from './constants'
import { useStyles } from './style'
import Icon from '../../utils/icons'
import { forwardTo } from '../../utils/helper'
import { vppService, eventService } from '../../Services'
import { SOMETHING_WENT_WRONG } from '../../Constants/MessagesConstant'
import { ERROR, SUCCESS } from '../../utils/messageTypes'
import { getProgramById } from '../../AppRedux/actions/Programs'
import { timeZoneAbbrs } from '../../utils/momentTimezones'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'
import chargeFromPv from '../../Assets/Images/chargeFromPv.svg'
import chargeFromNetPv from '../../Assets/Images/chargeFromNetPv.svg'
import chargeFromPvAndGrid from '../../Assets/Images/chargeFromPvAndGrid.svg'
import dischargeToLoad from '../../Assets/Images/dischargeToLoad.svg'
import dischargeToNetLoad from '../../Assets/Images/dischargeToNetLoad.svg'
import dischargeToLoadAndGrid from '../../Assets/Images/dischargeToLoadAndGrid.svg'
import { ExpandLess } from '@material-ui/icons'
import { pushToDataLayer, USERBEHAVIOURTRACKING } from '../../utils/gaEnvironment'

moment.fn.zoneName = function () {
  const abbr = this.zoneAbbr()
  return timeZoneAbbrs[abbr] || abbr
}

const subTypeImgMapper = {
  'Charge from PV': chargeFromPv,
  'Charge from Net PV': chargeFromNetPv,
  'Charge from PV and Grid': chargeFromPvAndGrid,
  'Discharge to Load': dischargeToLoad,
  'Discharge to Net Load': dischargeToNetLoad,
  'Discharge to Load and Grid': dischargeToLoadAndGrid
}

function CreateEvents(props) {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const [vppList, setVppList] = useState([])
  const [selectedVpp, setSelectedVpp] = useState([])
  const [selectedVppQuery, setSelectedVppQuery] = useState({})
  const [openMessage, setOpenMessage] = useState(false)
  const [message, setMessage] = useState('')
  const [calendarOpen, setCalendarOpen] = useState(false)
  const [selectedInput, setSelectedInput] = useState('')
  const [validEndTime, setEndTimeValidDuration] = useState(true)
  const [validStartTime, setStartTimeValidDuration] = useState(true)
  const [totDuration, setTotDuration] = useState(0)
  const [defaultVppId, setDefaultVppId] = useState('')
  const [showConfirmPopup, setShowConfirmPopup] = useState(false)
  const [payload, setPayload] = useState({})
  const [eventName, setEventName] = useState('')
  const [eventType, setEventType] = useState('')
  const [eventSubType, setEventSubType] = useState('')
  const [targetSoc, setTargetSoc] = useState(90)
  const [scheduledPower, setScheduledPower] = useState('')
  const [calculatedScheduledEnergy, setCalculatedScheduledEnergy] = useState(0)
  const [showTypes, setShowTypes] = useState(false)
  const [accordianType, setAccordianType] = useState('')
  const [cardHovered, setCardHovered] = useState('')
  const [scheduledPowerHelperText, setScheduledPowerHelperText] = useState('')
  const [energyBasedProgram, setEnergyBasedProgram] = useState()
  const [powerBasedProgram, setPowerBasedProgram] = useState()
  const [scheduledEnergy, setScheduledEnergy] = useState('')
  const [inputValue, setInputValue] = useState()
  const [startTimeFormat, setStartTimeFormat] = useState('')
  const [endTimeFormat, setEndTimeFormat] = useState('')
  const [startTime, setStartTime] = useState()
  const [endTime, setEndTime] = useState()
  const [minSoc, setMinSoc] = useState(0)
  const [maxSoc, setMaxSoc] = useState(100)

  const minEventDuration = _.get(selectedVppQuery, 'min_event_duration', 900000)
  const eventLeadTime = _.get(props, 'programDetails.feature_flags.event_lead_time', 900)

  const timezone = props.timeZone
  const initialTime = moment.tz(timezone).add(Math.ceil(eventLeadTime / 60), 'minutes')
  const initialDate = {
    startTime: initialTime.format(CalendarFormat),
    endTime: initialTime.add(Math.ceil((Math.floor(minEventDuration / 1000)) / 60), 'minutes').format(CalendarFormat)
  }

  useEffect(() => {
    const id = _.get(props.match.params, 'programs_id', '')

    if (props.accountId && id && id !== props.programId) {
      props.getProgramById({
        accountId: props.accountId,
        programId: id
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params])

  useEffect(() => {
    if (props.accountId && props.programId) {
      setLoading(true)
      vppService.getAllProgramVpp(props.accountId, props.programId)
        .then((response) => {
          const defaultObj = response.find(obj => {
            const query = _.get(obj, 'query', {})
            const tag = _.get(query, 'tags', {})
            return _.isEmpty(tag)
          })

          if (!_.isEmpty(defaultObj)) {
            setDefaultVppId(defaultObj.id || '')
            setSelectedVpp([defaultObj.id || ''])
          }

          response.forEach((obj, index) => {
            if (obj.id === defaultObj.id) {
              response.splice(index, 1)
              response.unshift(obj)
            }
          })

          setVppList(response)
          setLoading(false)
        })
        .catch(() => {
          setLoading(false)
        })
      setEnergyBasedProgram(props.programDetails?.feature_flags?.event_feature_config?.DEFAULT.committed_energy_in_program || props.programDetails?.feature_flags?.committed_energy_in_program)
      setPowerBasedProgram(props.programDetails?.feature_flags?.event_feature_config?.DEFAULT.committed_power_in_program || props.programDetails?.feature_flags?.committed_power_in_program)
    }
  }, [props.accountId, props.programId])

  useEffect(() => {
    if (props.accountId && props.programId && !_.isEmpty(selectedVpp) && (!energyBasedProgram)) {
      setLoading(true)
      eventService.getVppSites(selectedVpp, props.accountId, props.programId)
        .then((response) => {
          setLoading(false)
          setSelectedVppQuery(response)
          setScheduledPower(response.total_battery_power)
        })
        .catch(() => {
          setLoading(false)
        })
    }
  }, [selectedVpp, props.accountId, props.programId])

  useEffect(() => {
    if (props.accountId && props.programId && !_.isEmpty(selectedVpp) && (energyBasedProgram) && eventType && targetSoc) {
      setLoading(true)
      eventService.getVppSites(selectedVpp, props.accountId, props.programId, targetSoc, eventType, startTimeFormat, endTimeFormat, energyBasedProgram)
        .then((response) => {
          setLoading(false)
          setSelectedVppQuery(response)
        })
        .catch(() => {
          setLoading(false)
        })
    }
  }, [selectedVpp, props.accountId, props.programId, startTimeFormat, endTimeFormat, targetSoc, eventType])

  useEffect(() => {
    if ((energyBasedProgram) && endTime && startTime && !_.isEmpty(selectedVpp)) {
      setScheduledEnergy(!_.isNil(selectedVppQuery.scheduled_energy) ? Math.max(0, selectedVppQuery.scheduled_energy) : selectedVppQuery.total_battery_charge)
      setScheduledPower(!_.isNil(selectedVppQuery.scheduled_power) ? Math.max(0, selectedVppQuery.scheduled_power) : selectedVppQuery.total_battery_power)
    }
  }, [totDuration, selectedVppQuery, selectedVpp])

  useEffect(() => {
    if (_.isEmpty(selectedVpp) && !_.isEmpty(selectedVppQuery)) {
      if (energyBasedProgram) {
        setScheduledEnergy(0)
        setScheduledPower(0)
      } else {
        setScheduledPower(0)
      }
    }
  }, [selectedVpp])

  useEffect(() => {
    if (eventSubType && eventType && eventType !== EVENT_TYPE.IDLE) {
      const selectedSubtype = props?.programDetails?.feature_flags?.event_subtypes?.find(subType => subType.name === eventSubTypes[eventSubType]?.value)
      if (eventType === 'Charge Event') {
        setMinSoc(selectedSubtype.min_target_soc + 1)
        setMaxSoc(selectedSubtype.max_target_soc)
      } else if (eventType === 'Discharge Event') {
        setMinSoc(selectedSubtype.min_target_soc)
        setMaxSoc(selectedSubtype.max_target_soc - 1)
      } else {
      }
    }
  }, [eventSubType])

  useEffect(() => {
    if (_.isEmpty(selectedVppQuery)) {
      setCalculatedScheduledEnergy(0)
    } else {
      if (eventType === 'Charge Event') {
        setCalculatedScheduledEnergy(selectedVppQuery.total_battery_charge * ((targetSoc - 10) / 100))
      } else if (eventType === 'Discharge Event') {
        setCalculatedScheduledEnergy(selectedVppQuery.total_battery_charge * ((100 - targetSoc) / 100))
      } else {
        setCalculatedScheduledEnergy(0)
      }
    }
  }, [selectedVppQuery, eventType, targetSoc])

  useEffect(() => {
    if (selectedVppQuery) {
      let message = ''
      if (eventType === 'Idle Event') {
        message = 'Batteries will stay idle'
      } else if (eventType === 'Charge Event') {
        message = 'Batteries will charge at'
      } else {
        message = 'Batteries will discharge to'
      }
      const power = selectedVppQuery.total_battery_power ? '100' : '0'
      setScheduledPowerHelperText(`${message} ${power}% of their committed power`)
    }
  }, [eventType, selectedVppQuery])

  const makeAPICall = (value) => {
    setTargetSoc(value)
  }

  const debouncedAPICall = _.debounce(makeAPICall, 500)
  useEffect(() => {
    if (energyBasedProgram) {
      debouncedAPICall(inputValue)
      return () => {
        debouncedAPICall.cancel()
      }
    }
  }, [inputValue, debouncedAPICall])

  const initialValues = () => {

    return {
      eventName,
      eventType,
      eventSubType,
      targetSoc,
      scheduledPower,
      scheduledEnergy,
      startTime,
      endTime,
      vpp: selectedVpp ? selectedVpp : [defaultVppId]
    }
  }

  const schema = Yup.object({
    eventName: Yup.string().matches(/^([A-Za-z0-9 ]+)$/, 'Event name not valid. Only letters, numbers are allowed').max(80, 'Event name should max 80 characters').required('This field is required'),
    eventType: Yup.string().required('Event Type is required'),
    eventSubType: Yup.string(),
    targetSoc: Yup.string().required('Target SoC is required').matches(/^([0-9]+)$/, 'Target SoC should not contain decimal value').test('targetSocRange', `Target SoC should be between ${minSoc} and ${maxSoc}`, val => Number(val) <= maxSoc && Number(val) >= minSoc),
    scheduledPower: Yup.string().required('Scheduled Power is required').test('max', `Scheduled power should not be greater than committed power`, val => Number(val) <= selectedVppQuery.total_battery_power),
    scheduledEnergy: Yup.string().when([], {
      is: () => energyBasedProgram,
      then: Yup.string().required('Scheduled Energy is required').test('max', `Scheduled energy should not be greater than committed energy`, val => Number(val) <= selectedVppQuery.total_battery_charge),
      otherwise: Yup.string().notRequired(),
    }),
    startTime: Yup.string().required('This field is required'),
    endTime: Yup.string().required('This field is required'),
    vpp: Yup.array().of(Yup.string()).required('This field is required')
  })

  const renderIcon = (errors, touched, id) => {
    if (!_.isEmpty(touched)) {
      return touched[id] ? _.isUndefined(errors[id]) ? <Icon src="circleTick" /> : <Icon src="circleCross" /> : <></>
    }
    return <></>
  }

  const handleBack = () => {
    forwardTo(`/programs/${props.programId}`)
  }

  const handleDone = (data, setFieldValue, id, values) => {
    const minEventDurationMinutes = Math.ceil(Math.floor(minEventDuration / 1000) / 60)
    const maxEventDuration = _.get(selectedVppQuery, 'max_event_duration', 14400000)
    const maxEventDurationMinutes = Math.ceil(maxEventDuration / 60000)
    if (id === 'startTime' && !_.isUndefined(values.endTime)) {
      const cur = moment.tz(timezone).add(minEventDurationMinutes, 'minutes')
      const selectedTime = moment.tz(data.dateTime, CalendarFormat, timezone)
      const isValid = selectedTime.isSameOrAfter(cur, 'minutes')
      const diff = moment(values.endTime, CalendarFormat).tz(timezone).diff(moment(data.dateTime, CalendarFormat).tz(timezone), 'minutes')

      const duration = moment.tz(values.endTime, CalendarFormat, timezone).diff(moment.tz(data.dateTime, CalendarFormat, timezone), 'minutes')
      const isEndTimeValid = moment.tz(values.endTime, CalendarFormat, timezone).isAfter(moment.tz(values.startTime, CalendarFormat, timezone)) && duration <= maxEventDurationMinutes && duration >= minEventDurationMinutes

      setStartTime(data.dateTime)
      setStartTimeValidDuration(isValid)
      setEndTimeValidDuration(isEndTimeValid)
      setTotDuration(diff)
    }

    if (id === 'endTime' && !_.isUndefined(values.startTime)) {
      const diff = moment(data.dateTime, CalendarFormat).tz(timezone).diff(moment(values.startTime, CalendarFormat).tz(timezone), 'minutes')
      const isValid = moment(data.dateTime, CalendarFormat).tz(timezone).isAfter(moment(values.startTime, CalendarFormat).tz(timezone)) && diff <= maxEventDurationMinutes && diff >= minEventDurationMinutes

      setEndTime(data.dateTime)
      setEndTimeValidDuration(isValid)
      setTotDuration(diff)
    }
    if (id === 'startTime') {
      const selectedTime = moment.tz(data.dateTime, CalendarFormat, timezone)
      const isValid = selectedTime.isBefore(moment.tz(timezone).add(7, 'days'), 'minutes')
      setStartTime(data.dateTime)
      setStartTimeValidDuration(isValid)
    }
    if (id === 'endTime') {
      setEndTime(data.dateTime)
    }
    setFieldValue(id, data.dateTime)
    setCalendarOpen(false)
  }

  const renderPopupContent = () => (
    <Box className={classes.popWrapper}>
      <Typography className={classes.popupTitle}>Are you sure you want to create a new event with the systems selected?</Typography>
      <Typography className={classes.popText}>The selected {_.get(selectedVppQuery, 'total_systems', 0)} systems will be opted-in to the event and any further change to the selected VPPs or underlying tags won’t impact the system selection.</Typography>
      <Box className={classes.buttonGroup}>
        <AppButton text='Yes' className={classes.ackButton} onClick={handleConfirm} />
        <AppButton text='No' fill={false} className={classes.ackButton} onClick={() => setShowConfirmPopup(false)} />
      </Box>

    </Box>
  )

  const handleMessageClose = (event, reason) => {
    // if (reason === COMMON.CLICKAWAY) {
    //   return
    // }

    setOpenMessage(false)
  }

  const handleClickDuration = (id) => {
    setSelectedInput(id)
    setCalendarOpen(true)
  }

  const getMaxDate = (id) => {
    return moment.tz(timezone).add(7, 'days').format('YYYY-MM-DD')
  }

  const renderDuration = (minutes) => {
    const hr = parseInt(minutes / 60)
    const min = minutes % 60
    let hrView = ''
    let minView = ''

    if (hr >= 1) {
      hrView = `${hr} ${hr > 1 ? 'Hours' : 'Hour'} `
    }
    if (min >= 1) {
      minView = `${min} ${min > 1 ? 'Minutes' : 'Minute'}`
    }

    if (startTime && endTime) {
      setStartTimeFormat(startTime ? moment.tz(startTime, CalendarFormat, timezone).utc().format('MM-DD-YYYY hh:mm:ss A') : '')
      setEndTimeFormat(endTime ? moment.tz(endTime, CalendarFormat, timezone).utc().format('MM-DD-YYYY hh:mm:ss A') : '')
    }
    return _.isEmpty(hrView) && _.isEmpty(minView) ? '--' : `${hrView} ${_.isEmpty(hrView) ? '' : ' '} ${minView}`
  }

  const getMaxEventDuration = () => {
    const duration = _.get(selectedVppQuery, 'max_event_duration', 14400000)
    let seconds = Math.floor(duration / 1000)
    let minutes = Math.floor(seconds / 60)
    let hours = Math.floor(minutes / 60)
    seconds = seconds % 60
    minutes = minutes % 60
    return `${hours} Hours ${minutes} Minutes`
  }

  const renderErrorMessage = id => {
    if (id === 'startTime') {
      return !validStartTime && <Typography className={classes.errorMessage}>Start time must be greater than or equal to {Math.ceil(eventLeadTime / 60)} mins and less than 7 days of current time</Typography>
    }
    return !validEndTime && <Typography className={classes.errorMessage}>End time must be greater than start time. Event duration should be atleast {Math.ceil(Math.floor(minEventDuration / 1000) / 60)} minutes and not exceed {getMaxEventDuration()}</Typography>
  }

  const renderDateTimePicker = (obj, values, errors, touched, setFieldValue) => {
    return (
      <Box className={classes.dateInput}>
        <TextField
          id={obj.id}
          name={obj.name}
          label={obj.label}
          InputProps={{
            classes: { root: classes.input, underline: classes.underline },
            type: obj.type === 'number' ? 'number' : 'text',
            endAdornment: <ExpandMoreIcon />,
            readOnly: true
          }}
          disabled={obj.name === 'endTime' && !startTime}
          classes={{ root: classes.dateTimeInput }}
          InputLabelProps={{ classes: { root: classes.input, shrink: classes.shrink } }}
          value={values[obj.id] ? moment.tz(values[obj.id], CalendarFormat, timezone).format('MM-DD-YYYY hh:mm A zz') : ''}
          onClick={() => obj.name === 'endTime' ? startTime && handleClickDuration(obj.id) : handleClickDuration(obj.id)}
        />
        {renderErrorMessage(obj.id)}
        {calendarOpen && selectedInput === obj.id && (
          <DateTimePicker
            value={values[obj.id] ? values[obj.id] : initialDate[obj.id]}
            maxDate={getMaxDate(obj.id)}
            minDate={moment().tz(timezone).format('YYYY-MM-DD')}
            format={CalendarFormat}
            timezone={timezone}
            handleCancel={() => setCalendarOpen(false)}
            handleDone={((data) => handleDone(data, setFieldValue, obj.id, values))} />
        )}
      </Box>
    )
  }

  const renderTypeAndSubtype = (obj, values, errors, touched, setFieldValue) => {
    const isSubTypeIdle = obj.id === 'eventSubType' && eventSubType === 'Idle'
    return (
      <>
        <Box className={classes.typeInput}>
          <TextField
            id={obj.id}
            name={obj.name}
            label={obj.label}
            InputProps={{
              classes: { root: classes.input, underline: classes.underline },
              type: obj.type === 'number' ? 'number' : 'text',
              ...(isSubTypeIdle ? {} : { endAdornment: accordianType === obj.id ? <ExpandLess /> : <ExpandMoreIcon /> }),
              readOnly: true
            }}
            disabled={isSubTypeIdle}
            classes={{ root: classes.customTypeInput }}
            InputLabelProps={{ classes: { root: classes.input, shrink: classes.shrink } }}
            value={values[obj.id]}
            onClick={() => { if (!(isSubTypeIdle)) { setShowTypes(true); setAccordianType(obj.id) } }}
          />
          {showTypes && accordianType === 'eventType' && obj.id === 'eventType' && showEventTypes(values, setFieldValue)}
          {showTypes && accordianType === 'eventSubType' && obj.id === 'eventSubType' && showEventSubTypes(values, setFieldValue)}
        </Box>
      </>
    )
  }

  const showEventTypes = (values, setFieldValue) => {
    return (
      <ClickAwayListener onClickAway={() => { setShowTypes(false); setAccordianType('') }}>
        <Box display="flex" flexWrap="wrap" justifyContent="space-around" my={2} py={2} className={classes.accordianWrapper}>
          {eventTypes.map((eventType, index) => (
            props.programDetails && props.programDetails.feature_flags && props.programDetails.feature_flags.event_types && props.programDetails.feature_flags.event_types.includes(eventType.value) &&
            <Box display="flex" alignItems="flex-start" key={eventType.value} my={2}>
              <Radio
                checked={values.eventType === eventType.name}
                onChange={(e) => { setFieldValue('eventType', e.target.value); setFieldValue('eventSubType', ''); setEventType(e.target.value); setShowTypes(true); setAccordianType('eventSubType'); if (e.target.value === 'Idle Event') { setShowTypes(false); setAccordianType(''); setFieldValue('eventSubType', 'Idle'); setEventSubType('Idle'); setTargetSoc(100); setInputValue(100); setFieldValue('targetSoc', 100) } }}
                value={eventType.name}
                name={eventType.name}
                checkedIcon={<CheckCircleIcon />}
                icon={cardHovered === eventType.filename ? <CheckCircleIcon color="primary" /> : <RadioButtonUncheckedIcon />}
                onMouseEnter={() => {
                  setCardHovered(eventType.filename)
                  const card = document.getElementById(eventType.filename)
                  card && card.classList.add(classes.hoveredEventBox)
                }}
                onMouseLeave={() => {
                  setCardHovered('')
                  const card = document.getElementById(eventType.filename)
                  card && card.classList.remove(classes.hoveredEventBox)
                }}
                disableRipple
                color="primary"
              />
              <Box className={classes.typeBoxWrapper} id={eventType.filename} onClick={() => { setFieldValue('eventType', eventType.name); setEventType(eventType.name); setShowTypes(true); setAccordianType('eventSubType'); if (values.eventType !== eventType.name) { setFieldValue('eventSubType', ''); setEventSubType(''); if (eventType.name === 'Idle Event') { setShowTypes(false); setAccordianType(''); setFieldValue('eventSubType', 'Idle'); setEventSubType('Idle'); setTargetSoc(100); setInputValue(100); setFieldValue('targetSoc', 100) } } }} onMouseEnter={() => setCardHovered(eventType.filename)} onMouseLeave={() => setCardHovered('')}>
                <Box className={classes.eventNameTitle} p={1}>{eventType.name}</Box>
                <Box mb={3} px={1}><Divider /></Box>
                <Box display="flex" justifyContent="center" className={classes.eventTypeImage}><Icon src={eventType.filename} hovered={cardHovered} selected={values.eventType} /></Box>
                <Box className={classes.eventTypeDescription} my={3} px={3.75}>{eventType.description}</Box>
              </Box>
            </Box>
          ))
          }
        </Box>
      </ClickAwayListener>
    )
  }

  const showEventSubTypes = (values, setFieldValue) => {
    // const targetSocOverride = props && props.programDetails && props.programDetails.feature_flags && props.programDetails.feature_flags.target_soc_override
    return (
      <ClickAwayListener onClickAway={() => { setShowTypes(false); setAccordianType('') }}>
        <Box display="flex" flexWrap="wrap" justifyContent="space-around" my={2} py={2} className={classes.accordianWrapper}>
          {eventSubTypeMapper[values.eventType] && eventSubTypeMapper[values.eventType].map((eventSubType, index) => {
            const availableSubTypes = props.programDetails && props.programDetails.feature_flags && props.programDetails.feature_flags.event_subtypes && props.programDetails.feature_flags.event_subtypes.find(subtype => subtype.name === eventSubTypes[eventSubType].value)
            return (
              availableSubTypes &&
              <Box display="flex" alignItems="flex-start" key={eventSubType} my={2} style={{ color: 'red' }}>
                <Radio
                  className={classes.subTypeRadio}
                  checked={values.eventSubType === eventSubType}
                  onChange={(e) => { setFieldValue('eventSubType', e.target.value); setEventSubType(e.target.value); setShowTypes(false); setAccordianType(''); setTargetSoc(eventType === 'Charge Event' ? availableSubTypes.max_target_soc : availableSubTypes.min_target_soc); setInputValue(eventType === 'Charge Event' ? availableSubTypes.max_target_soc : availableSubTypes.min_target_soc); setFieldValue('targetSoc', eventType === 'Charge Event' ? availableSubTypes.max_target_soc : availableSubTypes.min_target_soc) }}
                  value={eventSubType}
                  name={eventSubType}
                  checkedIcon={<CheckCircleIcon />}
                  icon={cardHovered === eventSubType ? <CheckCircleIcon color="primary" /> : <RadioButtonUncheckedIcon />}
                  onMouseEnter={() => {
                    setCardHovered(eventSubType)
                    const card = document.getElementById(eventSubType)
                    card && card.classList.add(classes.hoveredEventBox)
                  }}
                  onMouseLeave={() => {
                    setCardHovered('')
                    const card = document.getElementById(eventSubType)
                    card && card.classList.remove(classes.hoveredEventBox)
                  }}
                  disableRipple
                  color="primary"
                />
                <Box className={classes.subTypeBoxWrapper} id={eventSubType} onClick={() => { setFieldValue('eventSubType', eventSubType); setEventSubType(eventSubType); setShowTypes(false); setAccordianType(''); setTargetSoc(eventType === 'Charge Event' ? availableSubTypes.max_target_soc : availableSubTypes.min_target_soc); setInputValue(eventType === 'Charge Event' ? availableSubTypes.max_target_soc : availableSubTypes.min_target_soc); setFieldValue('targetSoc', eventType === 'Charge Event' ? availableSubTypes.max_target_soc : availableSubTypes.min_target_soc) }} onMouseEnter={() => setCardHovered(eventSubType)} onMouseLeave={() => setCardHovered('')}>
                  <Box className={classes.eventNameTitle} p={1}>{eventSubType}</Box>
                  <Box mb={3} px={1}><Divider /></Box>
                  <Box display="flex" justifyContent="center" className={classes.eventTypeImage}><img src={subTypeImgMapper[eventSubType]} /></Box>
                  <Box className={classes.eventTypeDescription} my={3}>
                    <Box px={2.5}>POWER SCHEDULE PRIORITY :</Box>
                    <ol>
                      {eventSubTypes[eventSubType].description.map(detail => (
                        <li>{detail}</li>
                      ))}
                    </ol>
                  </Box>
                </Box>
              </Box>
            )
          }
          )}
        </Box>
      </ClickAwayListener>
    )
  }

  const handleConfirm = () => {
    setLoading(true)
    eventService.addNewEvent(payload, props.accountId)
      .then((response) => {
        const eventId = _.get(response, 'id', '')
        setLoading(false)
        setShowConfirmPopup(false)
        props.history.push({
          pathname: eventId ? `/programs/${props.programId}/events/${eventId}` : `/programs`,
          showMessage: true,
          message: 'Event created successfully',
          messageType: SUCCESS
        })
      })
      .catch((error) => {
        setLoading(false)
        const data = _.get(error, 'data', {})
        const errorObj = _.get(data, 'error', {})
        const displayMessage = _.get(errorObj, 'displayMessage', SOMETHING_WENT_WRONG)
        setOpenMessage(true)
        setMessage(displayMessage)
        setShowConfirmPopup(false)
      })
  }

  const renderCardContent = () => {
    return (
      <Box>
        <Formik
          enableReinitialize={true}
          initialValues={initialValues()}
          validationSchema={schema}
          onSubmit={(data) => {
            pushToDataLayer({ event: USERBEHAVIOURTRACKING, accountID: props.accountId, programID: props.programId })
            const params = {
              all_vpps: _.get(data, 'vpp', []),
              name: _.get(data, 'eventName', '') ? (_.get(data, 'eventName', '')).trim() : '',
              program_id: props.programId || '',
              type: _.get(data, 'eventType', '') ? eventTypeMapper[data.eventType] : '',
              subtype: data.eventSubType && eventSubTypes[data.eventSubType] ? eventSubTypes[data.eventSubType].value : 'Idle',
              start_date_time: _.get(data, 'startTime', '') ? moment.tz(_.get(data, 'startTime', ''), CalendarFormat, timezone).utc().format('MM-DD-YYYY hh:mm:ss A') : '',
              end_date_time: _.get(data, 'endTime', '') ? moment.tz(_.get(data, 'endTime', ''), CalendarFormat, timezone).utc().format('MM-DD-YYYY hh:mm:ss A') : '',
              vpp_rate_watt_kw: _.get(data, 'scheduledPower', ''),
              target_soc: _.get(data, 'targetSoc', ''),
              creator_email: _.get(props.currentUser, 'id', ''),
              account_id: _.get(props, 'programDetails.account_id', '')
            }
            if (!_.isEmpty(_.get(data, 'vpp', []))) {
              setShowConfirmPopup(true)
              setPayload(params)
            }
          }}
          render={({ values, errors, touched, dirty, isValid, setFieldValue }) => {
            return (
              <Form>
                <Box className={classes.formWrapper}>
                  <Box className={classes.durationPart}>
                    {eventForm(props.programDetails).map(obj => (
                      obj.type === 'custom' && (obj.id === 'eventType' || (values.eventType && values.eventType !== 'Idle')) &&
                      <Box className={`${obj.type !== 'custom' ? classes.inputRowWrapper : classes.customRowWrapper} `}>
                        {obj.type === 'select'
                          ? (<TextField
                            select
                            id={obj.id}
                            name={obj.name}
                            label={obj.label}
                            options={obj.options}
                            InputProps={{
                              classes: { root: classes.input, underline: classes.underline }
                            }}
                            SelectProps={{
                              MenuProps: {
                                classes: { paper: classes.paper },
                                anchorOrigin: {
                                  vertical: "bottom",
                                  horizontal: "left"
                                },
                                getContentAnchorEl: null
                              }
                            }}
                            classes={{ root: classes.inputWrapper }}
                            value={values[obj.id]}
                            onChange={(e) => {
                              setEventType(e.target.value)
                              setFieldValue(obj.id, e.target.value)
                            }}
                          >
                            {obj.options.map(option => {
                              return <MenuItem value={option.value}>{option.label}</MenuItem>
                            })}
                          </TextField>)
                          : (
                            obj.type === 'date'
                              ? (renderDateTimePicker(obj, values, errors, touched, setFieldValue))
                              : obj.type === 'custom' ? renderTypeAndSubtype(obj, values, errors, touched, setFieldValue)
                                : (<TextField
                                  id={obj.id}
                                  name={obj.name}
                                  label={obj.label}
                                  InputProps={{
                                    classes: { root: classes.input, underline: classes.underline },
                                    type: obj.type == 'number' ? 'number' : 'text',
                                    endAdornment: renderIcon(errors, touched, obj.id)
                                  }}
                                  // helperText={errors[obj.id]}
                                  classes={{ root: classes.inputWrapper }}
                                  InputLabelProps={{ classes: { root: classes.input, shrink: classes.shrink } }}
                                  value={values[obj.id]}
                                  onChange={(e) => {
                                    e.target.value = e.target.value ? obj.id === 'eventName' ? (e.target.value).slice(0, 80) : (e.target.value).slice(0, 30) : e.target.value
                                    setEventName(e.target.value)
                                    setFieldValue(obj.id, e.target.value)
                                  }}
                                />)
                          )}
                        <Typography className={classes.errorMessage}><ErrorMessage name={obj.name} /></Typography>
                      </Box>
                    ))
                    }
                  </Box>
                  {values.eventType && values.eventSubType &&
                    <>
                      <Box className={classes.vppPart}>
                        <Typography className={classes.vppLabel}>Select Virtual Power Plant</Typography>
                        {_.isEmpty(values.vpp) && <Typography className={classes.errorMessage}>Select atleast one Virtual Power Plant</Typography>}
                        <Box className={classes.vppWrapper} role='group'>
                          {vppList.map((obj, index) => (
                            <Box className={`${classes.vppListContent} ${values.vpp.some(list => list === _.get(obj, 'id', '')) && classes.selectedVpp}`}>
                              <Checkbox
                                icon={<CheckBoxOutlineBlankIcon fontSize="small" color="primary" />}
                                checkedIcon={<CheckBoxOutlinedIcon fontSize="small" color="primary" />}
                                name='vpp'
                                value={_.get(obj, 'id', '')}
                                checked={values.vpp.some(list => list === _.get(obj, 'id', ''))}
                                onChange={(event) => {
                                  let vppList = _.cloneDeep(_.get(values, 'vpp', [])) || []
                                  if (event.target.checked) {
                                    if (event.target.value === defaultVppId) {
                                      vppList = [defaultVppId]
                                    } else {
                                      vppList = vppList.filter(list => list !== defaultVppId)
                                      vppList.push(event.target.value)
                                    }
                                  } else {
                                    vppList = vppList.filter(list => event.target.value !== list)
                                  }
                                  setSelectedVpp(vppList)
                                  setFieldValue('vpp', vppList)
                                }}
                                classes={{ root: classes.checkBox }}
                              />
                              <Box className={classes.checkBoxLabelWrapper}>
                                <Typography className={classes.checkBoxLabel}>{_.get(obj, 'name', '')}</Typography>
                                <Box className={classes.row}>
                                  <Typography className={classes.label}>Systems</Typography>
                                  <Typography className={classes.value}>{_.get(obj, 'total_systems', '')}</Typography>
                                </Box>
                                <Box className={classes.row}>
                                  <Typography className={classes.label}>Total Energy</Typography>
                                  <Typography className={classes.value}>{`${_.get(obj, 'battery_capacity', '')?.toFixed(2)} kWh`}</Typography>
                                </Box>
                                <Box className={classes.row}>
                                  <Typography className={classes.label}>Total Power</Typography>
                                  <Typography className={classes.value}> {`${_.get(obj, 'nameplate_power', '')?.toFixed(2)} kW`}</Typography>
                                </Box>
                                {(energyBasedProgram) && <Box className={classes.row}>
                                  <Typography className={classes.label}>Committed Energy</Typography>
                                  <Typography className={classes.value}> {`${_.get(obj, 'committed_energy', '')?.toFixed(2)} kWh`}</Typography>
                                </Box>}
                                <Box className={classes.row}>
                                  <Typography className={classes.label}>Committed Power</Typography>
                                  <Typography className={classes.value}> {`${_.get(obj, 'total_power', '')?.toFixed(2)} kW`}</Typography>
                                </Box>
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      </Box>
                      <Box className={classes.durationPart}>
                        {(!energyBasedProgram) && eventForm(props.programDetails).map(obj => (
                          obj.type !== 'custom' &&
                          <Box className={`${obj.type !== 'custom' ? classes.inputRowWrapper : classes.customRowWrapper} `}>
                            {obj.type === 'select'
                              ? (<TextField
                                select
                                id={obj.id}
                                name={obj.name}
                                label={obj.label}
                                options={obj.options}
                                InputProps={{
                                  classes: { root: classes.input, underline: classes.underline }
                                }}
                                SelectProps={{
                                  MenuProps: {
                                    classes: { paper: classes.paper },
                                    anchorOrigin: {
                                      vertical: "bottom",
                                      horizontal: "left"
                                    },
                                    getContentAnchorEl: null
                                  }
                                }}
                                classes={{ root: classes.inputWrapper }}
                                value={values[obj.id]}
                                onChange={(e) => {
                                  setEventType(e.target.value)
                                  setFieldValue(obj.id, e.target.value)
                                }}
                              >
                                {obj.options.map(option => {
                                  return <MenuItem value={option.value}>{option.label}</MenuItem>
                                })}
                              </TextField>)
                              : (
                                obj.type === 'date'
                                  ? (renderDateTimePicker(obj, values, errors, touched, setFieldValue))
                                  : obj.type === 'custom' ? renderTypeAndSubtype(obj, values, errors, touched, setFieldValue)
                                    : (obj.hideFor && obj.hideFor.includes(eventType) ? null :
                                      <TextField
                                        id={obj.id}
                                        name={obj.name}
                                        label={obj.label}
                                        type={obj.type === 'number' ? 'number' : 'text'}
                                        disabled={(obj.id === 'targetSoc' && !(props?.programDetails?.feature_flags?.event_feature_config?.DEFAULT.target_soc_override ||
                                          props?.programDetails?.feature_flags?.target_soc_override)) ||
                                          (obj.id === 'scheduledPower' && !(props?.programDetails?.feature_flags?.event_feature_config?.DEFAULT.scheduled_power_override || props?.programDetails?.feature_flags?.scheduled_power_override))}
                                        InputProps={{
                                          classes: { root: classes.input, underline: classes.underline },
                                          endAdornment: <>
                                            {obj.icon ? <>
                                              <InputAdornment position="end" style={{ marginRight: '5px' }}>
                                                <Tooltip title={<Box className={classes.customPopperText}>{obj.tooltipMsg}</Box>} classes={{ tooltip: classes.customPopper }}>
                                                  <InfoOutlinedIcon color="primary" fontSize="small" style={{ cursor: 'pointer' }} />
                                                </Tooltip>
                                              </InputAdornment>
                                            </> : ''}
                                            {renderIcon(errors, touched, obj.id)}
                                          </>
                                        }}
                                        helperText={obj.id === 'scheduledPower' && <Box className={classes.scheduledPowerText}>{scheduledPowerHelperText}</Box>}
                                        classes={{ root: classes.inputWrapper }}
                                        InputLabelProps={{ classes: { root: classes.input, shrink: classes.shrink } }}
                                        value={values[obj.id]}
                                        onChange={(e) => {
                                          if (obj.id === 'eventName') {
                                            e.target.value = e.target.value ? obj.id === 'eventName' ? (e.target.value).slice(0, 80) : (e.target.value).slice(0, 30) : e.target.value
                                            setEventName(e.target.value)
                                            setFieldValue(obj.id, e.target.value)
                                          } else {
                                            e.target.value = e.target.value ? obj.id === 'eventName' ? (e.target.value).slice(0, 80) : (e.target.value).slice(0, 30) : e.target.value
                                            if (obj.id === 'targetSoc') {
                                              e.target.value = e.target.value ? e.target.value.toString().match(new RegExp(`^-?\\d+(?:d{0,0})?`)) ? e.target.value.toString().match(new RegExp(`^-?\\d+(?:d{0,0})?`))[0] : '' : ''
                                              if (e.target.value > 100) {
                                                e.target.value = Math.floor(e.target.value / 10)
                                              }
                                              setFieldValue(obj.id, e.target.value)
                                              setTargetSoc(e.target.value)
                                            }
                                            else {
                                              e.target.value = e.target.value ? e.target.value.toString().match(new RegExp(`^-?\\d+(?:\\.\\d{0,2})?`)) ? e.target.value.toString().match(new RegExp(`^-?\\d+(?:\\.\\d{0,2})?`))[0] : '' : ''
                                              setScheduledPowerHelperText(`${values['eventType'] === 'Idle Event' ? 'Batteries will stay idle' : `Batteries will ${values['eventType'] === 'Charge Event' ? 'charge at' : 'discharge to'} ${selectedVppQuery.total_battery_power ? Math.ceil((e.target.value / selectedVppQuery.total_battery_power) * 100) : '0'}% of their committed power`}`)
                                              setScheduledPower(e.target.value)
                                            }
                                            setFieldValue(obj.id, e.target.value)
                                          }
                                        }}
                                        onBlur={(e) => {
                                          if (obj.id === 'eventName') {
                                            let name = e.target.value.trim()
                                            setEventName(name)
                                            setFieldValue(obj.id, name)
                                          }
                                        }}
                                      />)
                              )}
                            <Typography className={classes.errorMessage}><ErrorMessage name={obj.name} /></Typography>
                          </Box>
                        ))
                        }
                        {(energyBasedProgram) && energyBasedEventForm(props.programDetails).map(obj => (
                          obj.type !== 'custom' &&
                          <Box className={`${obj.type !== 'custom' ? classes.inputRowWrapper : classes.customRowWrapper} `}>
                            {obj.type === 'select'
                              ? (<TextField
                                select
                                id={obj.id}
                                name={obj.name}
                                label={obj.label}
                                options={obj.options}
                                InputProps={{
                                  classes: { root: classes.input, underline: classes.underline }
                                }}
                                SelectProps={{
                                  MenuProps: {
                                    classes: { paper: classes.paper },
                                    anchorOrigin: {
                                      vertical: "bottom",
                                      horizontal: "left"
                                    },
                                    getContentAnchorEl: null
                                  }
                                }}
                                classes={{ root: classes.inputWrapper }}
                                value={values[obj.id]}
                                onChange={(e) => {
                                  setEventType(e.target.value)
                                  setFieldValue(obj.id, e.target.value)
                                }}
                              >
                                {obj.options.map(option => {
                                  return <MenuItem value={option.value}>{option.label}</MenuItem>
                                })}
                              </TextField>)
                              : (
                                obj.type === 'date'
                                  ? (renderDateTimePicker(obj, values, errors, touched, setFieldValue))
                                  : obj.type === 'custom' ? renderTypeAndSubtype(obj, values, errors, touched, setFieldValue)
                                    : (obj.hideFor && obj.hideFor.includes(eventType) ? null :
                                      <TextField
                                        id={obj.id}
                                        name={obj.name}
                                        label={obj.label}
                                        type={obj.type === 'number' ? 'number' : 'text'}
                                        disabled={(obj.id === 'targetSoc' && !(props?.programDetails?.feature_flags?.event_feature_config?.DEFAULT.target_soc_override ||
                                          props?.programDetails?.feature_flags?.target_soc_override)) ||
                                          (obj.id === 'scheduledPower') || (obj.id === 'scheduledEnergy')}
                                        InputProps={{
                                          classes: { root: classes.input, underline: classes.underline },
                                          endAdornment: <>
                                            {obj.icon ? <>
                                              <InputAdornment position="end" style={{ marginRight: '5px' }}>
                                                <Tooltip title={<Box className={classes.customPopperText}>{obj.tooltipMsg}</Box>} classes={{ tooltip: classes.customPopper }}>
                                                  <InfoOutlinedIcon color="primary" fontSize="small" style={{ cursor: 'pointer' }} />
                                                </Tooltip>
                                              </InputAdornment>
                                            </> : ''}
                                            {renderIcon(errors, touched, obj.id)}
                                          </>
                                        }}
                                        classes={{ root: classes.inputWrapper }}
                                        InputLabelProps={{ classes: { root: classes.input, shrink: classes.shrink } }}
                                        value={(obj.id === 'scheduledEnergy' || obj.id === 'scheduledPower') && !targetSoc ? '' : values[obj.id]}
                                        onChange={(e) => {
                                          if (obj.id === 'eventName') {
                                            e.target.value = e.target.value ? obj.id === 'eventName' ? (e.target.value).slice(0, 80) : (e.target.value).slice(0, 30) : e.target.value
                                            setEventName(e.target.value)
                                            setFieldValue(obj.id, e.target.value)
                                          } else {
                                            e.target.value = e.target.value ? obj.id === 'eventName' ? (e.target.value).slice(0, 80) : (e.target.value).slice(0, 30) : e.target.value
                                            if (obj.id === 'targetSoc') {
                                              e.target.value = e.target.value ? e.target.value.toString().match(new RegExp(`^-?\\d+(?:d{0,0})?`)) ? e.target.value.toString().match(new RegExp(`^-?\\d+(?:d{0,0})?`))[0] : '' : ''
                                              if (e.target.value > 100) {
                                                e.target.value = Math.floor(e.target.value / 10)
                                              }
                                              setFieldValue(obj.id, e.target.value)
                                              setInputValue(e.target.value)
                                            }
                                            else {
                                              e.target.value = e.target.value ? e.target.value.toString().match(new RegExp(`^-?\\d+(?:\\.\\d{0,2})?`)) ? e.target.value.toString().match(new RegExp(`^-?\\d+(?:\\.\\d{0,2})?`))[0] : '' : ''
                                            }
                                            setFieldValue(obj.id, e.target.value)
                                          }
                                        }}
                                      />)
                              )}
                            <Typography className={classes.errorMessage}><ErrorMessage name={obj.name} /></Typography>
                          </Box>
                        ))

                        }
                      </Box>
                      <Box className={classes.yourSectionWrapper}>
                        <Box className={classes.yourSectionTitleWrapper} mb={2}>
                          <Typography className={classes.yourSectionTitle}>Your Selection</Typography>
                        </Box>
                        <Box className={classes.yourSectionContentWrapper}>
                          <Grid container spacing={4}>
                            <Grid item xs={12} md={4}>
                              <Box className={classes.sectionRow}>
                                <Typography className={classes.sectionLabel}>Event Type</Typography>
                                <Typography className={classes.sectionValue}>{eventType}</Typography>
                              </Box>
                              <Box my={1}>
                                <Divider />
                              </Box>
                              <Box className={classes.sectionRow}>
                                <Typography className={classes.sectionLabel}>Event Sub Type</Typography>
                                <Typography className={classes.sectionValue}>{eventSubType}</Typography>
                              </Box>
                              <Box my={1}>
                                <Divider />
                              </Box>
                              <Box className={classes.sectionRow}>
                                <Typography className={classes.sectionLabel}>Event Name</Typography>
                                <Typography className={classes.sectionValue}>{eventName}</Typography>
                              </Box>
                            </Grid>
                            {eventType !== 'Idle Event' &&
                              <>
                                <Grid item xs={12} md={4}>
                                  <Box className={classes.sectionRow}>
                                    <Typography className={classes.sectionLabel}>Target SoC</Typography>
                                    <Typography className={classes.sectionValue}>{`${targetSoc ? targetSoc + ' %' : '--'}`}</Typography>
                                  </Box>
                                  <Box my={1}>
                                    <Divider />
                                  </Box>
                                  <Box className={classes.sectionRow}>
                                    <Typography className={classes.sectionLabel}>Scheduled Power</Typography>
                                    <Typography className={classes.sectionValue}>{`${!_.isNil(scheduledPower) && (typeof scheduledPower === 'string' ? !_.isEmpty(scheduledPower) : true) && targetSoc ? scheduledPower + ' kW' : '--'}`}</Typography>
                                  </Box>
                                  <Box my={1}>
                                    <Divider />
                                  </Box>
                                  {(!energyBasedProgram) && <Box className={classes.sectionRow}>
                                    <Typography className={classes.sectionLabel}>Scheduled Energy</Typography>
                                    <Typography className={classes.sectionValue}>{`${Math.max(0, Math.min(calculatedScheduledEnergy.toFixed(2), (scheduledPower * (totDuration / 60)).toFixed(2)))} kWh`}</Typography>
                                  </Box>}
                                  {(energyBasedProgram) && <Box className={classes.sectionRow}>
                                    <Typography className={classes.sectionLabel}>Scheduled Energy</Typography>
                                    <Typography className={classes.sectionValue}>{`${!_.isNil(scheduledEnergy) && (typeof scheduledEnergy === 'string' ? !_.isEmpty(scheduledEnergy) : true) && targetSoc ? scheduledEnergy + ' kWh' : '--'}`}</Typography>
                                  </Box>}
                                </Grid>
                                <Grid item xs={12} md={4}>
                                  <Box className={classes.sectionRow}>
                                    <Typography className={classes.sectionLabel}>Total Event Power</Typography>
                                    <Typography className={classes.sectionValue}>{`${selectedVppQuery.total_battery_power ? selectedVppQuery.total_battery_power : 0} kW`}</Typography>
                                  </Box>
                                  <Box my={1}>
                                    <Divider />
                                  </Box>
                                  <Box className={classes.sectionRow}>
                                    <Typography className={classes.sectionLabel}>Total Event Energy</Typography>
                                    <Typography className={classes.sectionValue}>{`${selectedVppQuery.total_battery_charge ? (selectedVppQuery.total_battery_charge).toFixed(2) : 0} kWh`}</Typography>
                                  </Box>
                                </Grid>
                              </>
                            }
                          </Grid>
                          <Typography className={classes.note}>{totDuration ? <Box component='span'>The total event duration is <span>{renderDuration(totDuration)}</span>. </Box> : ''}Maximum event duration allowed is {getMaxEventDuration()}.</Typography>
                        </Box>
                      </Box>
                      <hr className={classes.hr} />
                      <Box className={classes.buttonWrapper}>
                        <AppButton text='BACK' onClick={handleBack} fill={false} className={classes.button} />
                        <AppButton text="SUBMIT" className={`${classes.button} `} type="submit" />
                      </Box>
                    </>
                  }
                </Box >
              </Form >
            )
          }}
        />
      </Box >
    )
  }

  const renderNavValues = () => {
    const nav = [{ 'Home': '/' }, { 'Programs': '/programs' }]
    nav.push(
      { [_.get(props.programDetails, 'program_name_admin_ui', '')]: `/programs/${props.programId}` },
      { 'Events': `/programs/${props.programId}/events` },
      { 'Create a New Event': '' }
    )
    return nav
  }

  return (
    <Box>
      <Breadcrumb value={renderNavValues()} />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>Create a New Event</Typography>
      </Box>
      <Cards children={renderCardContent()} className={classes.cardsWrapper} />
      <Loader loading={loading} />
      <Popup
        open={showConfirmPopup}
        disableBackdropClick
        content={renderPopupContent()}
      />
      <DisplayMessage open={openMessage} message={message} messageType={ERROR} handleClose={handleMessageClose} />
    </Box>
  )
}

const mapDispatchToProps = (dispatch) => ({
  getProgramById: (payload) => dispatch(getProgramById(payload)),
})

const mapStateToProps = ({ auth, programs }) => {
  const { currentUser, accountId, timeZone } = auth
  const { programDetails, programId } = programs
  return { currentUser, accountId, timeZone, programDetails, programId }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateEvents)